import { render, staticRenderFns } from "./ContractHistoryDisplay.vue?vue&type=template&id=d27a38ba&scoped=true&"
import script from "./ContractHistoryDisplay.vue?vue&type=script&lang=js&"
export * from "./ContractHistoryDisplay.vue?vue&type=script&lang=js&"
import style0 from "./ContractHistoryDisplay.vue?vue&type=style&index=0&id=d27a38ba&prod&scoped=true&lang=css&"
import style1 from "./ContractHistoryDisplay.vue?vue&type=style&index=1&id=d27a38ba&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d27a38ba",
  null
  
)

export default component.exports